import { gql } from '@apollo/client';

export const REGISTER_KEYCLOAK_USER = gql`
  mutation RegisterKeycloakUser($user: UserInput!) {
    registerKeycloakUser(user: $user) {
      __typename
      ... on CreateUserSuccess {
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
